import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"];
  static values = {
    initialItems: Number,
    limit: Number
  }

  connect() {
    const totalItems = this.itemTargets.length
    const initial = this.initialItemsValue || 4

    if (totalItems > initial) {
      this.itemTargets.forEach((el, index) => {
        el.style.display = index < initial ? "" : "none"
      })
    } else {
      // 全件表示なので「さらに表示」ボタンを非表示にする
      const moreButton = this.element.querySelector('[data-read-more-target="button_area"]')
      if (moreButton) moreButton.style.display = "none"
    }
  }

  open(e) {
    e.preventDefault()
    const limit = this.limitValue || 4
    const currentlyVisible = this.itemTargets.filter(el => el.style.display !== "none").length
    const nextVisible = currentlyVisible + limit

    this.itemTargets.forEach((el, index) => {
      if (index < nextVisible) el.style.display = ""
    })

    if (nextVisible >= this.itemTargets.length) {
      const moreButton = this.element.querySelector('[data-read-more-target="button_area"]')
      if (moreButton) moreButton.style.display = "none"
    }
  }
}
